(() => {
  const weekdays = ['日', '月', '火', '水', '木', '金', '土'];

  const renderDeliveryDates = () => {
    document.querySelectorAll('[data-luna-delivery-date]').forEach((element) => {
      const days = Number.parseInt(element.dataset.lunaDeliveryDate || '7', 10);
      const safeDays = Number.isFinite(days) ? days : 7;
      const date = new Date();
      date.setDate(date.getDate() + safeDays);
      element.textContent = `最短${date.getMonth() + 1}月${date.getDate()}日（${weekdays[date.getDay()]}）到着`;
    });
  };

  const setupStickyAtc = () => {
    const sticky = document.querySelector('[data-gloss-sticky-atc]');
    if (!sticky) return;

    const media = window.matchMedia('(max-width: 749px)');
    const update = () => {
      if (!media.matches) {
        sticky.classList.remove('is-visible');
        return;
      }

      const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
      const formRect = productForm ? productForm.getBoundingClientRect() : null;
      const shouldShow = window.scrollY > 520 && (!formRect || formRect.bottom < 120 || formRect.top > window.innerHeight);
      sticky.classList.toggle('is-visible', shouldShow);
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const replacements = [
    ['尾巴', '裾幅'],
    ['下摆', '裾幅'],
    ['合身', '標準フィット'],
    ['衣长', '着丈'],
    ['衣長', '着丈'],
    ['肩宽', '肩幅'],
    ['肩寬', '肩幅'],
    ['胸围', '胸囲'],
    ['胸圍', '胸囲'],
    ['袖长', '袖丈'],
    ['袖長', '袖丈'],
    ['尺码', 'サイズ'],
    ['尺寸', 'サイズ'],
    ['面料', '素材'],
    ['均码', 'ワンサイズ'],
    ['exia', '着用イメージ']
  ];

  const normalizeText = (text) =>
    replacements.reduce((value, [from, to]) => value.replaceAll(from, to), text);

  const normalizeVariantLabel = (text) =>
    normalizeText(text)
      .replace(/^\s*180\s+/u, '')
      .replace(/\s*180枚\s*$/u, '')
      .replace(/洗濯して破いた|洗って破いた/gu, 'ウォッシュダメージ')
      .replace(/洗濯してちぎった|洗ってちぎった/gu, 'ウォッシュカット')
      .replace(/(ウォッシュダメージ|ウォッシュカット)(ホワイト|アプリコット)/u, '$1 $2')
      .replace(/(ホワイト|アプリコット)(M|L|XL|2XL|3XL|4XL)$/u, '$1 $2')
      .replace(/\s{2,}/gu, ' ')
      .trim();

  const normalizeProductCopy = () => {
    document.querySelectorAll('.product-form__input input[type="radio"] + label').forEach((label) => {
      const textNode = [...label.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
      if (!textNode) return;
      textNode.nodeValue = ` ${normalizeVariantLabel(textNode.nodeValue)} `;
    });

    document.querySelectorAll('.product__description, .product__accordion, .rte').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          if (node.parentElement?.closest('script, style, noscript')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        node.nodeValue = normalizeText(node.nodeValue);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      renderDeliveryDates();
      setupStickyAtc();
      normalizeProductCopy();
    });
  } else {
    renderDeliveryDates();
    setupStickyAtc();
    normalizeProductCopy();
  }
})();
